// Centralized Cloudinary Configuration
export const CLOUDINARY_CONFIG = {
  cloudName: process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || "dihji7b10",
  uploadPreset: process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || "muj_upload",
  resourceType: "image",
  maxFiles: 1,
  maxImageFileSize: 1500000,
};

/**
 * Creates and opens a Cloudinary upload widget
 * @param {Function} onUploadSuccess Callback with (secureUrl, resultInfo)
 * @param {Function} [onUploadError] Optional error callback
 * @param {Object} [customOptions] Override options
 */
export const openCloudinaryWidget = (onUploadSuccess, onUploadError, customOptions = {}) => {
  if (!window.cloudinary) {
    console.error("Cloudinary widget script is not loaded");
    if (onUploadError) onUploadError(new Error("Cloudinary script not loaded"));
    return null;
  }

  const widget = window.cloudinary.createUploadWidget(
    {
      ...CLOUDINARY_CONFIG,
      ...customOptions,
    },
    (error, result) => {
      if (error) {
        console.error("Cloudinary upload error:", error);
        if (onUploadError) onUploadError(error);
        return;
      }
      if (result && result.event === "success") {
        const secureUrl = result.info.secure_url;
        if (onUploadSuccess) {
          onUploadSuccess(secureUrl, result.info);
        }
      }
    }
  );

  widget.open();
  return widget;
};

export default CLOUDINARY_CONFIG;
